import { useQuery } from '@tanstack/react-query'
import type { UseQueryResult } from '@tanstack/react-query'

import { queryKeys } from '../../../../config/queryKeys'
import { getPlayerScheduleGameStats } from '../../../../services/player/playerGameStats'
import type { GameStat, StatsRole } from '../types'

export interface UsePlayerScheduleGamesArgs {
  playerId?: string
  scheduleId: string | null
  role: StatsRole
}

/** Per-game stats for one season, fetched when that season row is expanded. */
export const usePlayerScheduleGames = ({
  playerId,
  scheduleId,
  role,
}: UsePlayerScheduleGamesArgs): UseQueryResult<GameStat[], Error> => {
  'use memo'

  return useQuery({
    queryKey: queryKeys.playerStats.scheduleGames(playerId, scheduleId, role),
    queryFn: () =>
      getPlayerScheduleGameStats({
        playerId: playerId as string,
        scheduleId: scheduleId as string,
        role,
      }),
    enabled: Boolean(playerId) && scheduleId !== null,
  })
}

export default usePlayerScheduleGames
